module.exports = __webpack_public_path__ + "640d65b195c11516c08d708e295954f8.MP3";